import axios from "@/util/axios";
export default {
    hasMeeting(objectType, objectId){
        return axios.get(`/api/meeting/has`, { params: { tapd_object_type: objectType, tapd_object_id: objectId } });
    },
    getStatus (objectType, objectId) {
        return axios.get(`/api/meeting/get`, { params: { tapd_object_type: objectType, tapd_object_id: objectId } });
    },
    create (params, configs = {}) {
        return axios.post('api/meeting/create', params, configs);
    },
    cancelObjectMeeting (meetingId) {
        return axios.post('api/meeting/cancel', meetingId);
    },
    loadObjectMessage(params) {
        return axios.get('api/meeting/invitaionForm', {params});
    },
    authorize () {
        return axios.get('api/meeting/authorize');
    },
    authorizeCallback (params) {
        return axios.get('api/meeting/authorize/callback', {params});
    },
    authorizeGet () {
        return axios.get('api/meeting/get-access-token', {showError: false});
    },
    stateGet () {
        return axios.get('api/meeting/get-state', {showError: false});
    },    
    meetingObjId(meetingId){
        return axios.get('api/meeting/object', {params: {meetingId: meetingId}});
    },
    jsTicket(url){
        return axios.get('api/meeting/js_ticket', {params: {url: url}});
    }
}